var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9801",
    d: "m19.262 9 9.5-7.52a2.012 2.012 0 0 1 2.48 0L40.74 9z",
    opacity: 1,
    "data-original": "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f57c00",
    d: "M31.24 1.48a2.012 2.012 0 0 0-2.48 0l-.26.206L37.74 9h3z",
    opacity: 1,
    "data-original": "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9801",
    d: "M59 25.38v.53l-4 3.45v-9.08l2.49 1.97A4.012 4.012 0 0 1 59 25.38zM5 20.28v9.08l-4-3.45v-.53a4.012 4.012 0 0 1 1.51-3.13z",
    opacity: 1,
    "data-original": "#ff9801"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M21.19 43.31 2.33 57.97A3.944 3.944 0 0 1 1 55V25.91l4 3.45z",
    opacity: 1,
    "data-original": "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3a",
    d: "M57.67 57.97A3.984 3.984 0 0 1 55 59H5a3.984 3.984 0 0 1-2.67-1.03l18.86-14.66 7.57-5.88a2.012 2.012 0 0 1 2.48 0l7.57 5.88z",
    opacity: 1,
    "data-original": "#ffeb3a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdd834",
    d: "m38.81 43.31-7.57-5.88a2.012 2.012 0 0 0-2.48 0l-.26.2 7.31 5.678L54.67 57.97A3.984 3.984 0 0 1 52 59h3c.987 0 1.938-.368 2.67-1.03z",
    opacity: 1,
    "data-original": "#fdd834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdf00",
    d: "M59 25.91V55a3.944 3.944 0 0 1-1.33 2.97L38.81 43.31 55 29.36z",
    opacity: 1,
    "data-original": "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec108",
    d: "M56 28.5V55a3.967 3.967 0 0 1-.288 1.448l1.958 1.522A3.944 3.944 0 0 0 59 55V25.91z",
    opacity: 1,
    "data-original": "#fec108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M55 11v18.36L38.81 43.31l-7.57-5.88a2.012 2.012 0 0 0-2.48 0l-7.57 5.88L5 29.36V11a2.006 2.006 0 0 1 2-2h46a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M53 9h-3a2.006 2.006 0 0 1 2 2v18.36L37.232 42.085l1.578 1.225L55 29.36V11a2.006 2.006 0 0 0-2-2z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillRule: "nonzero",
    d: "M58.11 21.466 56 19.8V11a3 3 0 0 0-3-3H41.089L31.855.691A3.014 3.014 0 0 0 28.139.7L22.705 5A7 7 0 0 0 9 7v1H7a3 3 0 0 0-3 3v8.8l-2.114 1.669A4.987 4.987 0 0 0 0 25.38V55a5.006 5.006 0 0 0 5 5h50a5.006 5.006 0 0 0 5-5V25.38a4.989 4.989 0 0 0-1.89-3.914zM57.531 56.6 40.386 43.271 58 28.091V55c0 .567-.163 1.122-.469 1.6zm-.665-33.565A2.993 2.993 0 0 1 58 25.38v.072l-2 1.724v-4.83zM29.375 2.269c.364-.287.878-.29 1.244-.005L37.865 8H23v-.684zM11 7a5 5 0 0 1 10 0v1h-2V7a3 3 0 0 0-6 0v1h-2zm0 3h2v7a1 1 0 0 0 2 0v-7h2v8a3 3 0 0 1-6 0zm4-2V7a1 1 0 0 1 2 0v1zm-8 2h2v8a5 5 0 0 0 10 0v-8h34a1 1 0 0 1 1 1v17.9L38.775 42.02l-6.92-5.378a3.011 3.011 0 0 0-3.709 0l-6.921 5.378L6 28.9V11a1 1 0 0 1 1-1zM2.469 56.6A2.974 2.974 0 0 1 2 55V28.091l17.615 15.18zm.661-33.566.87-.688v4.83l-2-1.724v-.072a2.991 2.991 0 0 1 1.13-2.346zM5 58a2.961 2.961 0 0 1-.887-.149l25.262-19.633a1.015 1.015 0 0 1 1.252 0l25.26 19.631A2.961 2.961 0 0 1 55 58z",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.96e6aa46a2d80ff73314d940b49ab7cf.svg";
export { ForwardRef as ReactComponent };